import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const PROJECTS = [
    {
        category: "Data Analytics",
        title: "Restaurant Sales Dashboard",
        desc: "Interactive sales and performance dashboard for a restaurant business.",
        img: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?q=85&w=1200&auto=format&fit=crop",
    },
    {
        category: "Website Design",
        title: "Business Website",
        desc: "Modern and responsive website designed for a growing local business.",
        img: "https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?q=85&w=1200&auto=format&fit=crop",
    },
    {
        category: "Social Media Creatives",
        title: "Instagram Campaign",
        desc: "Creative social media posts and promotional content for brand promotion.",
        img: "https://images.unsplash.com/photo-1724862936518-ae7fcfc052c1?q=85&w=1200&auto=format&fit=crop",
    },
    {
        category: "Logo & Branding",
        title: "Brand Identity",
        desc: "Custom logo and modern brand identity design for a business.",
        img: "https://images.unsplash.com/photo-1777652918753-d66882b15391?q=85&w=1200&auto=format&fit=crop",
    },
];

export default function Projects() {
    return (
        <section id="portfolio" className="py-20 lg:py-28" data-testid="projects-section">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <span className="h-px w-10 bg-gold-deep" />
                            <span className="text-[11px] font-semibold tracking-[0.34em] text-burgundy">OUR WORK</span>
                        </div>
                        <h2 className="text-4xl sm:text-5xl text-charcoal">Featured Projects</h2>
                    </div>
                    <p className="max-w-md text-charcoal/70 md:text-right">
                        Explore our recent work in data analytics, web design, branding and digital content.
                    </p>
                </Reveal>

                <div className="grid md:grid-cols-2 gap-x-8 gap-y-14">
                    {PROJECTS.map((p, i) => (
                        <Reveal key={p.title} delay={(i % 2) * 0.08}>
                            <article className="group" data-testid={`project-card-${i}`}>
                                <div className="img-zoom relative rounded-2xl overflow-hidden aspect-[4/3] shadow-[0_24px_50px_-30px_rgba(90,0,16,0.35)]">
                                    <img src={p.img} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                                    <span className="absolute top-4 left-4 bg-cream/95 backdrop-blur text-burgundy text-[10px] font-semibold tracking-[0.22em] px-3.5 py-1.5 rounded-full">
                                        {p.category.toUpperCase()}
                                    </span>
                                </div>
                                <div className="pt-6">
                                    <h3 className="text-2xl text-charcoal">{p.title}</h3>
                                    <p className="mt-2 text-sm text-charcoal/65 max-w-lg">{p.desc}</p>
                                    <a
                                        href="#portfolio"
                                        className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-burgundy border-b border-transparent hover:border-burgundy/50 transition-all pb-0.5"
                                        data-testid={`project-view-${i}`}
                                    >
                                        View Project
                                        <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                                    </a>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>

                <Reveal className="mt-16 text-center">
                    <a href="#portfolio" className="btn btn-outline group" data-testid="projects-view-all">
                        View All Projects
                        <ArrowRight className="btn-arrow w-4 h-4" />
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
